import { DescriptionRunEventDTOSkipReasonEnum, GetDescriptionRunEventsActionEnum } from "@app/api/generated";

/** i18n key per outcome. Keyed by the (structurally identical) request/DTO action enum. */
export const EVENT_ACTION_LABEL_KEY: Record<GetDescriptionRunEventsActionEnum, string> = {
  [GetDescriptionRunEventsActionEnum.WRITTEN]: "productDescription.event.action.written",
  [GetDescriptionRunEventsActionEnum.SKIPPED]: "productDescription.event.action.skipped",
  [GetDescriptionRunEventsActionEnum.ERROR]: "productDescription.event.action.error",
  [GetDescriptionRunEventsActionEnum.CLAIMED_BY_HAND]: "productDescription.event.action.claimedByHand",
  [GetDescriptionRunEventsActionEnum.PRODUCT_GONE]: "productDescription.event.action.productGone"
};

/** Why nothing was written. The ESB sends this alongside SKIPPED and ERROR rows. */
export const SKIP_REASON_LABEL_KEY: Record<DescriptionRunEventDTOSkipReasonEnum, string> = {
  [DescriptionRunEventDTOSkipReasonEnum.LOW_CONFIDENCE]: "productDescription.event.reason.lowConfidence",
  [DescriptionRunEventDTOSkipReasonEnum.BAD_LENGTH]: "productDescription.event.reason.badLength",
  [DescriptionRunEventDTOSkipReasonEnum.API_ERROR]: "productDescription.event.reason.apiError"
};
